import { find, forEach, split } from "lodash";
import useGetBasePath from "~/hooks/useGetBasePath";

const getBreadcrumbs = ({ title, uri, ancestors, getBasePath }) => {
    const home = getBasePath("pagesBase");

    const crumbs = [
        {
            pathname: home ? home.url : "/",
            crumbLabel: home ? home.label : "Home",
        },
    ];

    const slugs = split(uri, "/");

    forEach(slugs, (slug) => {
        const ancestor = find(ancestors?.nodes, { slug });

        if (ancestor) {
            const stop = ancestor.uri.indexOf("?");
            const languageCode = ancestor.languageCode;

            let pathname = ancestor.uri;

            if (stop > -1) {
                pathname = ancestor.uri.slice(0, stop);
            }

            if (languageCode !== "en") {
                pathname = `${pathname}${languageCode}`;
            }

            crumbs.push({ pathname, crumbLabel: ancestor.title });
        }
    });

    crumbs.push({ crumbLabel: title });

    return crumbs;
};

const usePageBreadcrumbs = (data) => {
    const getBasePath = useGetBasePath();

    const {
        wpPage: { title, ancestors, uri },
    } = data;

    return getBreadcrumbs({ title, uri, ancestors, getBasePath });
};

export default usePageBreadcrumbs;
